import { EditorView, GutterMarker, gutter } from '@codemirror/view';
import { RangeSetBuilder } from '@codemirror/state';
import { syntaxTree } from '@codemirror/language';

class StringValueMarker extends GutterMarker {
    constructor(
        readonly line?: number,
        readonly onClick?: () => void,
    ) {
        super();
    }

    override toDOM(): HTMLElement {
        const icon = document.createElement('span');
        icon.innerHTML = '✏️';
        icon.title = 'Edit value';
        icon.className = 'json-gutter-icon';
        icon.style.cursor = 'pointer';
        icon.style.userSelect = 'none';
        icon.style.padding = '0 4px';
        icon.onmousedown = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onClick?.();
        };
        return icon;
    }
}

const jsonGutterTheme = EditorView.baseTheme({
    '.cm-gutters': {
        backgroundColor: '#f9f9f9',
        borderRight: '1px solid #ddd',
    },
    '.json-gutter-icon': {
        fontSize: '14px',
        lineHeight: '1',
        padding: '0 4px',
        userSelect: 'none',
        transition: 'transform 0.15s ease-in-out',
        color: '#c792ea',
    },
    '.json-gutter-icon svg': {
        verticalAlign: 'middle',
    },
});

const stringGutter = (callback: (oldValue: string, updateValue: (newValue: string) => void) => void) =>
    gutter({
        class: 'cm-json-gutter',
        markers: (view: EditorView) => {
            const tree = syntaxTree(view.state);
            const rangeSetBuilder = new RangeSetBuilder<StringValueMarker>();

            if (tree) {
                tree.iterate({
                    enter: (node) => {
                        if (node.name === 'String') {
                            const from = node.from;
                            const to = node.to;
                            const text = view.state.doc.sliceString(from, to);
                            const line = view.state.doc.lineAt(from);
                            const marker = new StringValueMarker(line.number, () => {
                                const current = JSON.parse(text) as string;
                                callback(current, (newValue: string) => {
                                    const quoted = JSON.stringify(newValue);
                                    view.dispatch({
                                        changes: { from, to, insert: quoted },
                                    });
                                });
                            });
                            rangeSetBuilder.add(line.from, line.to, marker);
                        }
                    },
                });
            }
            return rangeSetBuilder.finish();
        },
        initialSpacer: () => new StringValueMarker(),
    });

export function jsonStringEditorGutter(callback: (oldValue: string, updateValue: (newValue: string) => void) => void) {
    return [stringGutter(callback), jsonGutterTheme];
}
